// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__BoLwe","header":"ClearentDisclaimer_header__2L2nL","inner":"ClearentDisclaimer_inner__2jLIp"};